module.exports = __webpack_public_path__ + "img/⼯商业储能系统-液冷.ec6dfe2f.png";